import { Anchor, Fish, Bird, Sailboat, Sun, Wheat, Flame, Sprout, Cross, Star } from "lucide-react";
import { API } from "@/lib/api";

export const EMBLEM_ICONS: Record<string, any> = { anchor: Anchor, fish: Fish, dove: Bird, sailboat: Sailboat, sun: Sun, wheat: Wheat, flame: Flame, sprout: Sprout, cross: Cross, star: Star };
export const EMBLEM_COLORS = ["#1E293B", "#C86D51", "#5B7065", "#D97706", "#3D5A80", "#8C5E58"];
const ART_BASE = "https://static.prod-images.emergentagent.com/jobs/2bfd65d8-4762-4154-9373-440077215f5a/images/";
export const ART_AVATARS: Record<string, { label: string; file: string }> = {
  dove: { label: "Dove of peace", file: "4b177bc57526997697cb0f17bbf01a5192f8a9b1ea0247b99057fe656ccf4546" },
  lamb: { label: "Lamb", file: "eb46f6df156b4ac01676f8d82ac011df65c932c412dae31dd5faba21ac14cb69" },
  lion: { label: "Lion of Judah", file: "1ddcda0ca65cd60da6c78a2d921d4c471f033449312809e2a175ac2510e895f0" },
  fish: { label: "Ichthys fish", file: "d178b4f8adbab5474cef7a08277c0b1c9077bd52a76228773a79a60a61d7d1c0" },
  cross: { label: "Cross on a hill", file: "b1ce936ec17857daf0736bbad4cdac1606db1a80daa0161d5ad0e54251d9d369" },
  boat: { label: "Fishing boat", file: "f649856aeecd49532190a0ddff9a381295fd9ffb0fdd8825cc42ac73cf8de387" },
  lily: { label: "Lilies of the field", file: "9d0bb0783d8d84c26d1854d7f265ed4ebc55a7b917b1c30781a5fd54351f7eb2" },
  lamp: { label: "Lamp unto my feet", file: "a63a131b9368b121940e8686dbb5dac0415993842381c399f86e47fe09fee002" },
  bible: { label: "Open Bible", file: "ae7243b33531d54e66488bdb6f4765b06f77098112b80b01562acbdf3ddbbc23" },
  rainbow: { label: "Rainbow promise", file: "f723e5fc0a9597ec7226d44b0f0d59fbe7837e85cf8375fe2f8c18fc53b4a83e" },
};
export const artUrl = (k: string) => `${ART_BASE}${ART_AVATARS[k].file}.jpeg`;

export const Emblem = ({ avatar, size = 40 }: { avatar?: any; size?: number }) => {
  const img = avatar?.photo ? `${API}${avatar.photo}` : avatar?.art && ART_AVATARS[avatar.art] ? artUrl(avatar.art) : null;
  if (img) return <img src={img} alt="" data-testid="emblem-image" className="inline-block shrink-0 rounded-full object-cover ring-2 ring-white shadow-sm" style={{ width: size, height: size }} />;
  const Icon = EMBLEM_ICONS[avatar?.icon] || Anchor;
  const color = avatar?.color || "#1E293B";
  return (
    <span className="inline-flex shrink-0 items-center justify-center rounded-full ring-2 ring-white shadow-sm"
      style={{ width: size, height: size, background: `radial-gradient(circle at 30% 25%, ${color}cc, ${color})` }}>
      <Icon className="text-[#FAF7F2]" style={{ width: size * 0.48, height: size * 0.48 }} strokeWidth={1.8} />
    </span>
  );
};

export const ArtPicker = ({ value, onChange, prefix = "emblem" }: { value: any; onChange: (v: any) => void; prefix?: string }) => (
  <div className="flex flex-wrap gap-2.5">
    {Object.entries(ART_AVATARS).map(([k, a]) => (
      <button key={k} type="button" title={a.label} data-testid={`${prefix}-art-${k}`} onClick={() => onChange({ art: k })}
        className={`rounded-full p-0.5 transition-transform hover:scale-110 ${value?.art === k ? "ring-2 ring-[#C86D51] ring-offset-2" : ""}`}>
        <img src={artUrl(k)} alt={a.label} className="h-12 w-12 rounded-full object-cover" />
      </button>
    ))}
  </div>
);

export const EmblemPicker = ({ value, onChange, prefix = "emblem" }: { value: any; onChange: (v: any) => void; prefix?: string }) => {
  const icon = value?.icon || "anchor";
  const color = value?.color || EMBLEM_COLORS[0];
  return (
    <div className="space-y-4">
      <ArtPicker value={value} onChange={onChange} prefix={prefix} />
      <div className="flex flex-wrap gap-2">
        {Object.keys(EMBLEM_ICONS).map((k) => (
          <button key={k} type="button" data-testid={`${prefix}-icon-${k}`} onClick={() => onChange({ icon: k, color })}
            className={`rounded-full p-0.5 transition-transform hover:scale-110 ${value?.icon === k ? "ring-2 ring-[#C86D51] ring-offset-2" : ""}`}>
            <Emblem avatar={{ icon: k, color }} size={40} />
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        {EMBLEM_COLORS.map((c) => (
          <button key={c} type="button" data-testid={`${prefix}-color-${c.slice(1)}`} onClick={() => onChange({ icon, color: c })}
            className={`h-7 w-7 rounded-full transition-transform hover:scale-110 ${value?.icon && value.color === c ? "ring-2 ring-offset-2 ring-[#C86D51]" : ""}`} style={{ background: c }} />
        ))}
      </div>
    </div>
  );
};
